<template>
  <span class="h-text-primary" :style="{ fontSize: `${size}rem` }">
    <slot>{{ text }}</slot>
  </span>
</template>

<script>
export default {
  name: 'PrimaryText',
  props: {
    text: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 0.875,
    },
  },
};
</script>
<story
  options="{
    panelPosition: 'right'
  }"
  group="Common|Atoms/Text"
  name="PrimaryText"
  knobs="{
    text: {
      default: text('Text', 'Text for label')
    },
    size: {
      default: number('Size', 1)
    },
  }"
>
  <PrimaryText v-bind="{text, size}"/>
</story>
